/** The verdict palette every insights surface reads a figure's standing from. */
export const POSITIVE_COLOR = "#0D8157";
export const NEGATIVE_COLOR = "#B62028";
export const NEUTRAL_COLOR = "#AEB6C4";
export const TARGET_COLOR = "#D9822B";
